class Bucket {
    constructor(interactive, def) {
        this.name = def.label;
        this.visible = typeof def.visible === "undefined" || def.visible;
        this.color = def.color;
        this.interactive = interactive;
        this.label_ui = this.generate_label();
        this.color_ui = this.generate_color();
        this.label_ui.prepend(this.color_ui);
    }
    on() {
        this.visible = true;
        this.label_ui.removeClass("crossed-out");
        this.color_ui.removeClass("desaturated");
    }
    off() {
        this.visible = false;
        this.label_ui.addClass("crossed-out");
        this.color_ui.addClass("desaturated");
    }
    toggle() {
        this.visible = !this.visible;
        this.label_ui.toggleClass("crossed-out", !this.visible);
        this.color_ui.toggleClass("desaturated", !this.visible);
    }
    generate_label() {
        let label = $(`<div></div>`);
        label.addClass(this.interactive ? 'category interactive' : 'category');
        label.toggleClass("crossed-out", !this.visible);
        label.attr("id", this.color);
        label.text(this.name);
        return label;
    }
    generate_color() {
        let color = $(`<div></div>`);
        color.addClass("color");
        color.toggleClass("desaturated", !this.visible);
        color.attr("style", `background-color:${this.color} !important;`);
        return color;
    }
}
export class ThematicLegend {
    constructor(name, interactive, layer_defs) {
        this.name = name;
        this.buckets = [];
        this.repr = $();
        this.$legend = $();
        this.buckets = layer_defs.map(d => new Bucket(interactive, d));
        if (!this.buckets.every(x => x.name))
            return;
        this.repr = $("<div class='layer hidden'></div>");
        this.$legend = $(`<div class="legend">`);
        for (let bucket of this.buckets) {
            if (bucket.name) {
                this.$legend.append(bucket.label_ui);
            }
        }
        this.repr.append(this.$legend);
    }
    get active_buckets() { return this.buckets.filter(b => b.visible); }
    all_on() {
        this.buckets.forEach(b => b.on());
    }
    all_off() {
        this.buckets.forEach(b => b.off());
    }
    get_buckets(label) {
        return this.buckets.filter(b => b.name === label);
    }
    turn_on(label) {
        this.get_buckets(label).forEach(b => b.on());
    }
    turn_off(label) {
        this.get_buckets(label).forEach(b => b.off());
    }
    toggle(label) {
        this.get_buckets(label).forEach(b => b.toggle());
    }
}
